import React from 'react';
import {
  Grid, Typography, Button,
} from '@material-ui/core';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import Box from '@material-ui/core/Box';
import { FormattedMessage } from 'react-intl';
import LinkLocalized from './LinkLocalized';

const PageNotFound = () => (
  <Grid
    container
    spacing={0}
    alignItems="center"
    justifyContent="center"
    style={{ minHeight: '100vh' }}
  >
    <Grid
      item
      xs={12}
      sm={8}
      md={5}
    >
      <Grid container direction="row" alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <Grid container direction="row" alignItems="center" justifyContent="center">
            <Grid item>
              <Box my={4}>
                <ErrorOutline color="error" style={{ fontSize: 100 }} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container direction="row" alignItems="center" justifyContent="center">
            <Grid item>
              <Box mb={5}>
                <Typography variant="h3" align="center" gutterBottom color="error">
                  <FormattedMessage
                    id="NotFound.text"
                  />
                </Typography>
              </Box>
              <Box mb={5}>
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    component={LinkLocalized}
                    to="/"
                  >
                    <FormattedMessage
                      id="NotFound.home"
                    />
                  </Button>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box />
    </Grid>
  </Grid>
);

export default PageNotFound;
